export const addressOrDistance = (address: string, distance: number) => {
  if (!distance) {
    return address
  }
  const distanceString =
    distance < 1000
      ? `${Math.floor(distance)}m`
      : `${Math.floor(distance / 1000)}km`
  return `現在地から${distanceString}`
}
